import React, { useEffect, useState } from 'react';
import { useSpring, animated } from '@react-spring/web';
import styled, { keyframes, css } from 'styled-components';
import mcqueen from '../assets/mcqueen.png';
import wheel from '../assets/mcqueen_wheel.png'; // Suponiendo que usas la misma imagen para las ruedas

const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom, #8b0000 0%, #ff4500 40%, #222 100%);
  overflow: hidden;
  position: relative;
`;

const CarImage = styled(animated.img)`
  position: absolute;
  bottom: 10vh;
  width: 250px;
  height: auto;
  user-select: none;
  pointer-events: none;
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const wheelStyles = css`
  position: absolute;
  bottom: 10vh;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  user-select: none;
  pointer-events: none;
  animation: ${rotate} 0.75s linear infinite;
`;

const FrontWheel = styled(animated.img)`
  ${wheelStyles}
  left: 22px;
  margin-bottom: 2px;
`;

const RearWheel = styled(animated.img)`
  ${wheelStyles}
  left: 161px;
  margin-bottom: 9px;
`;

export default function RayoMcQueen() {
  const [windowWidth, setWindowWidth] = useState(0);
  const [duration, setDuration] = useState(5000);
  const [flip, setFlip] = useState(-1); // -1 = derecha, 1 = izquierda
  const [toggle, setToggle] = useState(false);

  const animation = useSpring({
    from: { left: toggle ? windowWidth + 50 : -300 },
    to: { left: toggle ? -300 : windowWidth + 50 },
    config: { duration },
    reset: true,
    onRest: () => {
      setFlip((prev) => prev * -1);
      setToggle((t) => !t);
    },
  });

  useEffect(() => {
    const width = window.innerWidth;
    setWindowWidth(width);
    setDuration(width < 768 ? 3000 : 5000);
  }, []);

  return (
    <Container>
      {windowWidth > 0 && (
        <>
          <CarImage
            style={{
              ...animation,
              transform: `scaleX(${flip})`,
            }}
            src={mcqueen}
            alt="Rayo McQueen"
          />
          <FrontWheel
            style={
              flip === 1
                ? {
                    animationDirection: 'reverse',
                    left: animation.left.to((val) => `${val + 161}px`),
                    marginBottom: '9px',
                  }
                : {
                    animationDirection: 'normal',
                    left: animation.left.to((val) => `${val + 40}px`),
                    marginBottom: '9px',
                  }
            }
            src={wheel}
            alt="Rayo McQueen Front Wheel"
          />
          <RearWheel
            style={
              flip === 1
                ? {
                    animationDirection: 'reverse',
                    left: animation.left.to((val) => `${val + 22}px`),
                    marginBottom: '2px',
                  }
                : {
                    animationDirection: 'normal',
                    left: animation.left.to((val) => `${val + 179}px`),
                    marginBottom: '2px',
                  }
            }
            src={wheel}
            alt="Rayo McQueen Rear Wheel"
          />
        </>
      )}
    </Container>
  );
}
